<template>
    <v-layout cow wrap class="solucoes container-fix">
        <v-flex xs12 class="titulo-centro">
            <h2> CONHEÇA NOSSAS SOLUÇÕES  </h2>

            <div class="risquinho-centro"></div>
        </v-flex>


        <v-flex md6 sm12 xs12>
            <v-list dark  three-line class="white--text item-lista ">
                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-tile>
                                <v-list-tile-avatar size="60" tile>
                                    <img :src="contratos" >
                                </v-list-tile-avatar>

                            <v-list-tile-content>
                                <strong>Contratos e Empresas</strong>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Consultivo e contencioso estratégico (arbitral e judicial) em Direito Civil
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Contratos e negócios jurídicos
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Consultoria para estruturação de empresas
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Implantação de novos negócios e modelos de investimentos
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Assessoria empresarial e societária
                        </v-card-text>
                    </v-card>


                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Negócios imobiliários
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Consultoria em Compliance e Lei Geral de Proteção de Dados – LGPD
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Recuperação judicial, falência e defesa de ativos
                        </v-card-text>
                    </v-card>

                </v-list-group>
            </v-list>
        </v-flex>


<!--   ------------------------------------------------------------------------- -->

        <v-flex md6 sm12 xs12>
            <v-list dark  three-line class="white--text item-lista ">
                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-avatar size="60" tile>
                                <img :src="eleitoral" >
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <strong>Direito Eleitoral e Parlamentar</strong>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Assessoria e contencioso na Justiça Eleitoral para agentes públicos, partidos políticos e entidades organizada
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Planejamento jurídico estratégico para campanhas eleitorais
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Financiamento e prestação de contas eleitorais e partidárias
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Cassação de mandato e decretação de inelegibilidade
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Direito Partidário
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Crimes eleitorais e conexos (lavagem de dinheiro e “Caixa Dois”)
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Contencioso estratégico e consultoria legislativa e parlamentar.
                        </v-card-text>
                    </v-card>

                </v-list-group>
            </v-list>
        </v-flex>


<!--   ------------------------------------------------------------------------- -->

        <v-flex md6 sm12 xs12>
            <v-list dark  three-line class="white--text item-lista ">
                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-avatar size="60" tile>
                                <img :src="familia" >
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <strong>Gestão Patrimonial, Família e Sucessões</strong>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Pactos antenupciais, contratos e dissolução de união estável
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Alteração de regime de bens, divórcios e partilha de bens
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Planejamento patrimonial e holdings familiares
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Planejamento sucessório e de riquezas individuais
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Adoção, reconhecimento de paternidade, guarda, alimentos e demais ações voltadas aos interesses de crianças e adolescentes
                        </v-card-text>
                    </v-card>


                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Inventários judiciais e extrajudiciais
                        </v-card-text>
                    </v-card>

                </v-list-group>
            </v-list>
        </v-flex>


        <!--   ------------------------------------------------------------------------- -->


        <v-flex md6 sm12 xs12>
            <v-list dark  three-line class="white--text item-lista ">
                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-avatar size="60" tile>
                                <img :src="muni" >
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <strong>Direito Administrativo e Contratos Públicos</strong>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Licitações e Contratos Administrativos
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Infraestrutura e setor energético
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Concessões de serviços públicos, Parcerias Público-Privadas e Terceiro Setor
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Concursos Públicos
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Agências Reguladoras e Estatais
                        </v-card-text>
                    </v-card>


                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Improbidade Administrativa: inquéritos civis e contencioso judicial
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Processos Administrativos e disciplinares
                        </v-card-text>
                    </v-card>

                </v-list-group>
            </v-list>
        </v-flex>


        <!--   ------------------------------------------------------------------------- -->

        <v-flex md6 sm12 xs12>
            <v-list dark  three-line class="white--text item-lista ">
                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-avatar size="50" tile>
                                <img :src="tributario" >
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <strong>Direito Tributário, Aduaneiro e Finanças</strong>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Contencioso e consultivo tributário
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Atuação perante o Conselho Administrativo de Recursos Fiscais (Carf)
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Atuação em processos administrativos fiscais
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Regime de tributação empresarial
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Benefícios Fiscais
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Direito aduaneiro: desembaraço de mercadorias e defesas administrativa
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Planejamento Tributário e Extrafiscalidade
                        </v-card-text>
                    </v-card>

                </v-list-group>
            </v-list>
        </v-flex>


        <!--   ------------------------------------------------------------------------- -->

        <v-flex md6 sm12 xs12>
            <v-list dark  three-line class="white--text item-lista ">
                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-avatar size="60" tile>
                                <img :src="tribunais" >
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <strong>Advocacy e Relações Governamentais</strong>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Elaboração de estratégias de relações governamentais com executivos e agentes políticos
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Participação em mesas de diálogo, fóruns e grupos sobre formulação de políticas públicas e legislativas
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Representação frente a organismos políticos e outras organizações sociais e internacionais
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Relacionamento com executivos e agentes políticos e governamentais
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Construção de teses, posicionamentos e notas técnicas em prol de causas de interesse público
                        </v-card-text>
                    </v-card>


                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Mapeamento dos processos de decisão política e planejamento de projetos
                        </v-card-text>
                    </v-card>

                </v-list-group>
            </v-list>
        </v-flex>


        <!--   ------------------------------------------------------------------------- -->

        <v-flex md6 sm12 xs12>
            <v-list dark  three-line class="white--text item-lista ">
                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-avatar size="60" tile>
                                <img :src="court" >
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <strong>Contencioso em Tribunais</strong>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Consultivo e contencioso estratégico em tribunais estaduais e federais
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Elaboração de memoriais para julgamento
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Despacho e audiências com Ministros, juízes e desembargadores
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Sustentação oral
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Recursos para os tribunais superiores
                        </v-card-text>
                    </v-card>

                </v-list-group>
            </v-list>
        </v-flex>


        <!--   ------------------------------------------------------------------------- -->

        <v-flex md6 sm12 xs12>
            <v-list dark  three-line class="white--text item-lista ">
                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-avatar size="60" tile>
                                <img :src="court" >
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <strong>Direito do Trabalho</strong>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Assessoria jurídica estratégica na gestão de empregados e nas rotinas trabalhistas diárias
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Atuação preventiva voltada à redução de passivos e à prevenção de litígios
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Defesa judicial de empresas em reclamatórias trabalhistas
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Acompanhamento em autos de infração, fiscalizações e procedimentos investigatórios perante o Ministério do Trabalho
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Revisão, elaboração e atualização de contratos de trabalho, regulamentos internos e políticas corporativas
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Mapeamento, análise e mitigação de riscos trabalhistas
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Condução de auditorias trabalhistas e atuação em processos de due diligence
                        </v-card-text>
                    </v-card>

                    <v-card class="elevation-0">
                        <v-card-text>
                            <span class="bolinha">•</span>
                            Cursos, workshops e treinamentos corporativos sob demanda, com foco em compliance trabalhista e boas práticas de gestão de pessoas
                        </v-card-text>
                    </v-card>

                </v-list-group>
            </v-list>
        </v-flex>


        <!--   ------------------------------------------------------------------------- -->

    </v-layout>
</template>

<script>
import muni from '../assets/municipal.png'
import eleitoral from '../assets/eleitoral.png'
import contratos from '../assets/contratos.png'
import familia from '../assets/familia.png'
import court from '../assets/court.png'
import tribunais from '../assets/tribunais.png'
import tributario from '../assets/tributario.png'

export default {
    data(){
        return{
            muni,
            eleitoral,
            contratos,
            familia,
            court,
            tribunais,
            tributario
        }
    }

}
</script>

<style scoped>
.v-list__tile__title{
    padding-left: 16px;
    /* height: 48px !important; */
    width: 100%;
    vertical-align: middle !important;
    white-space: unset !important; 
    overflow: unset !important;
}

.eleitoral .v-list__tile__title{
    height: 48px !important;
}





.v-list__tile__sub-title{
    white-space: unset !important; 
    text-overflow: unset !important;
    overflow: unset !important;
    height: 100%;
    display: flex;
    justify-content:center;
    align-content:center;
    flex-direction:column; 
}

.v-list__tile__content {
    padding-left: 20px;
}


.v-avatar {
    margin-top: 15px;
}

.theme--dark.v-list .v-list__group--active:before, .theme--dark.v-list .v-list__group--active:after{
    background: unset !important;
}

@media screen and (max-width: 474px) {
    .container-fix {
        padding-left: 16px;
        padding-right: 16px;
    }
}

@media screen and (max-width: 331px) {
    .container-fix {
        padding-left: 4px;
        padding-right: 4px;
    }
}

.item-lista {
    border-radius: 10px !important;
    margin: 16px;
}


.bolinha {
    color: #6ba348;
    font-size: 20px;
    font-weight: 999;
    line-height: 0px;
}

.v-card__text{
    padding: 16px 24px;
}
</style>
